import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './sidebar.module.scss';


type ComponentProps = {
    children: ReactNode;
    className?: string;
}


export function Sidebar ({ className, ...props }: ComponentProps) {
    return (
        <aside
            className={ cn(styles.root, className) }
            { ...props }
        />
    );
}
